export const siteConfig = {
  name: "Fabric",
  description: "Fabric",
  homePageText: "Welcome to Fabric - Your starting point for building amazing web applications.",
} 
